import React from "react";
import bbLogo from "../../Blackbird_Logo.png";
import UserMenu from "./UserMenu";
import PatientSearch from "./PatientSearch";

interface TopBarProps {
  email: string;
  onSelectPatient: (patientId: string, encounterId?: string) => void;
}

const TopBar: React.FC<TopBarProps> = ({ email, onSelectPatient }) => {
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <img
          src={bbLogo}
          alt="Blackbird Health"
          className="h-8 object-contain"
        />
        <h1 className="text-xl font-semibold text-gray-800">
          Precision Care Platform
        </h1>
      </div>

      <PatientSearch onSelectPatient={onSelectPatient} />

      <UserMenu email={email} />
    </header>
  );
};

export default TopBar;
